export const CATEGORIES_WITH_POSTS_QUERY = `*[_type == "category"]{
  _id,
  name,
  description,
  "imageUrl": image.asset->url,
  "posts": *[_type == "estatePost" && references(^._id)] | order(publishedAt desc)[0...5]{
    _id,
    title,
    slug,
    publishedAt,
    subtitle,
    "author": author->name,
    "authorImage": author->photo.asset->url,
    "imageUrl": mainImage.asset->url
  }
}`;

export const REFERENZEN_QUERY = `*[_type == "referenz" && showOnReferenzPage == true]{
  _id,
  name,
  description,
  quote,
  "avatar": avatar.asset->url,
  stars,
  title,
  "image": image.asset->url,
  date
}`;

export const POSTS_QUERY = `*[_type == "post" && defined(slug.current)]{
  _id,
  title,
  slug,
  publishedAt,
  body,
  "imageUrl": image.asset->url
}`;

export const CATEGORIES_QUERY = `*[_type == "category"]{
  name,
  description,
  "imageUrl": image.asset->url,
}`;

export const NAVBAR_BEITRAEGE_QUERY = `*[_type == "estatePost" && showInNavbar == true]{
  _id,
  title,
  slug
}`;

export const NAVBAR_VERKAUFEN_TIPPS_QUERY = `*[_type == "estatePost" && selectedTipps_verkaufen == true]{
  _id,
  title,
  slug
}`;

export const NAVBAR_KAUFEN_TIPPS_QUERY = `*[_type == "estatePost" && selectedTipps_kaufen == true]{
  _id,
  title,
  slug
}`;

export const NAVBAR_VERMIETEN_TIPPS_QUERY = `*[_type == "estatePost" && selectedTipps_vermieten == true]{
  _id,
  title,
  slug
}`;

export const POST_BY_SLUG_QUERY = `*[_type == "estatePost" && slug.current == $slug][0]{
  title,
  subtitle,
  publishedAt,
  "author": author->name,
  "authorImage": author->photo.asset->url,
  mainImage{
    asset->{
      _id,
      _ref,
      url
    },
    alt
  },
  content[]{
    ...,
    _type == "image" => {
      "url": asset->url,
      alt,
      caption
    }
  },
  relatedRatgeber->{
    title,
    description,
    "imageUrl": image.asset->url,
    "fileUrl": file.asset->url
  },
  category->{
    name,
    description,
    "imageUrl": image.asset->url,
  },
  merkmal,
  relatedPosts[]->{
    title,
    slug,
    mainImage{
      asset->{
        _id,
        _ref,
        url
      },
      alt
    },
  },
  seo
}`;

export const FILTERED_POSTS_PROJECTION = `{
  _id,
  title,
  "author": author->name,
  "authorImage": author->image.asset->url,
  "category":category->name,
  showInNavbar,
  slug,
  subtitle,
  publishedAt,
  "mainImageUrl": mainImage.asset->url,
  mainImage{
    alt
  }
}`;

// ====== CITY PAGES QUERIES ======

export const ALL_CITY_PAGES_QUERY = `*[_type == "cityPage" && published == true] | order(title asc) {
  _id,
  title,
  slug,
  description,
  "heroImageUrl": heroImage.asset->url,
  heroImage {
    alt
  },
  priority,
  _updatedAt
}`;

export const CITY_PAGE_BY_SLUG_QUERY = `*[_type == "cityPage" && slug.current == $slug && published == true][0]{
  _id,
  title,
  slug,
  description,
  heroImage {
    asset->{
      _id,
      _ref,
      url
    },
    alt
  },
  pageBuilder[]{
    ...,
    _type == "heroBlock" => {
      ...,
      image {
        asset->{url},
        alt
      }
    },
    _type == "textWithImageBlock" => {
      ...,
      image {
        asset->{url},
        alt
      },
      text[]{
        ...,
        _type == "image" => {
             "url": asset->url,
             alt
        }
      }
    },
    _type == "advantagesBlock" => {
      ...,
      items[]{
        ...,
        icon {
          asset->{
            _id,
            _ref,
            url
          },
          alt
        }
      }
    },
    _type == "reviewsBlock" => {
      ...,
      reviews[]->{
        author_name,
        rating,
        text,
        relative_time_description,
        time
      }
    }
  },
  published,
  seo,
  priority,
  _createdAt,
  _updatedAt
}`;

export const CITY_PAGES_SITEMAP_QUERY = `*[_type == "cityPage" && published == true] | order(priority desc, title asc) {
  "slug": slug.current,
  priority,
  _updatedAt
}`;

export const FOOTER_CITY_PAGES_QUERY = `*[_type == "cityPage" && published == true] | order(title asc) {
  title,
  slug
}`;
